var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1750818870470,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2152,
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M938.448 321.538l-260.505 203.29c-4.115 4.176-9.742 6.355-15.308 6.355-2.905 0-5.75-0.546-8.413-1.634-8.109-3.42-13.01-11.286-13.01-20.09v-121.69c-278.658 0-400.468 78.392-381.952 328.125C141.263 316.424 367.82 226.08 641.212 226.08V102.03c0-8.804 4.901-16.7 13.071-20.06 8.046-3.39 17.487-1.421 23.659 4.72l260.564 204.198c8.473 8.441 8.473 22.239-0.058 30.65zM780.391 812.894c0 36.732-29.955 66.563-66.746 66.563H212.969c-36.851 0-66.745-29.831-66.745-66.563V313.428c0-36.76 29.893-66.592 66.745-66.592l77.274-0.121 100.087-66.473H212.97c-73.583 0-133.49 59.757-133.49 133.186v499.466c0 73.4 59.907 133.187 133.49 133.187h500.676c73.582 0 133.488-59.786 133.488-133.187V460.291l-66.743 66.594v286.009h0.001z m0 0",
    "p-id": 2153,
    fill: "#8a8a8a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendIcon);
export default __webpack_public_path__ + "static/media/ResendIcon.8befb3840dfb0a67f56f38f0ea4175ec.svg";
export { ForwardRef as ReactComponent };